import {
	DESCRIPTION_MAX_LENGTH,
	TITLE_MAX_LENGTH,
} from 'constants/validationConstants'
import { TRANSFORMATION_STATUS } from 'services/mediaStorage'
import * as yup from 'yup'
import { InferType } from 'yup'

import { TTranslationFunction } from '@/types'

export const getVideoFormSchema = (t: TTranslationFunction) =>
	yup
		.object({
			videos: yup
				.array(
					yup.object({
						video: yup.object({
							name: yup
								.string()
								.required(t('ui__field_validation_errors__generic__required'))
								.max(
									TITLE_MAX_LENGTH,
									t('ui__field_validation_errors__generic__max_length', {
										length: TITLE_MAX_LENGTH,
									}),
								),
							originalName: yup.string().notRequired(),
							description: yup
								.string()
								.notRequired()
								.max(
									DESCRIPTION_MAX_LENGTH,
									t('ui__field_validation_errors__generic__max_length', {
										length: DESCRIPTION_MAX_LENGTH,
									}),
								),
							source: yup
								.object({
									demo: yup.string().notRequired(),
									uploaded: yup
										.object({
											publicId: yup.string().notRequired(),
											bucketRootUrl: yup.string().notRequired(),
											bytes: yup.number().notRequired(),
											format: yup.string().notRequired(),
											hasAutoTransformation: yup
												.string()
												.oneOf(Object.values(TRANSFORMATION_STATUS))
												.notRequired(),
											key: yup.string().notRequired(),
											resourceType: yup.string().notRequired(),
											storageProvider: yup.string().notRequired(),
										})
										.nullable()
										.notRequired(),
									url: yup.string().notRequired().nullable(),
								})
								.notRequired()
								.test(
									'source-required',
									t('ui__field_validation_errors__generic__required'),
									function (value) {
										return !!(
											value?.uploaded?.publicId ||
											value?.url ||
											value?.demo
										)
									},
								),
						}),
					}),
				)
				.required(),
		})
		.required()

export type TVideoFields = InferType<ReturnType<typeof getVideoFormSchema>>

export type TVideo = TVideoFields['videos'][number]
